
import {Vue, Component, Prop} from 'vue-property-decorator'
@Component({})
export default class BaseOptionsMenu extends Vue { 
  @Prop({default: "mdi-dots-vertical"}) icon !: string
  @Prop() title !: string
  @Prop({default: () => {}}) listProps !: object
  @Prop({default: 'overflow-y: auto; max-height: 500px;'}) listStyle !: string
}
